import { http, onSuccess, onFail } from "./http";

export const getStream = (id) =>
    http.get(`/api/cp/event/stream/${id}`)
        .then(onSuccess, onFail);

export const createStream = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/stream`, data)
        .then(onSuccess, onFail);

export const orderStream = (eventKey, data) =>
    http.post(`/api/cp/event/${eventKey}/stream/order`, data)
        .then(onSuccess, onFail);

export const updateStream = (id, data) =>
    http.put(`/api/cp/event/stream/${id}`, data)
        .then(onSuccess, onFail);

export const deleteStream = (id) =>
    http.delete(`/api/cp/event/stream/${id}`)
        .then(onSuccess, onFail);

export const addStreamDay = (id) =>
    http.post(`/api/cp/event/stream/${id}/stream`)
        .then(onSuccess, onFail);

export const createStreamLanguage = (streamID, data) =>
    http.post(`/api/cp/event/stream/${streamID}/language`, data)
        .then(onSuccess, onFail);

export const updateStreamLanguage = (id, data) =>
    http.put(`/api/cp/event/stream/language/${id}`, data)
        .then(onSuccess, onFail);

export const archiveStream = (id) =>
    http.post(`/api/cp/event/stream/${id}/archive`)
        .then(onSuccess, onFail);

export const checkStreamArchive = (id) =>
    http.post(`/api/cp/event/stream/${id}/archive/statusCheck`)
        .then(onSuccess, onFail);

export const resetStreamArchive = (id) =>
    http.delete(`/api/cp/event/stream/${id}/archive`)
        .then(onSuccess, onFail);

export const createStreamQuality = (streamId, data) =>
    http.post(`/api/cp/event/stream/${streamId}/quality`, data)
        .then(onSuccess, onFail);

export const updateStreamQuality = (id, data) =>
    http.put(`/api/cp/event/stream/quality/${id}`, data)
        .then(onSuccess, onFail);

export const enableStreamQualities = (streamId, ids) => 
    http.post(`/api/cp/event/stream/${streamId}/quality/enabled`, { ids })
        .then(onSuccess, onFail);

export const updateStreamPoster = (streamId, form) => 
    http.post(`/api/cp/event/stream/${streamId}/poster`, form)
        .then(onSuccess, onFail);

export const deleteStreamPoster = (streamId) =>
    http.delete(`/api/cp/event/stream/${streamId}/poster`)
        .then(onSuccess, onFail);